import {Component, ElementRef, HostBinding, Input, OnInit, Renderer2, ChangeDetectionStrategy} from '@angular/core';
import * as _ from 'lodash-es';
import {fromEvent, merge, Observable} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {destroy$} from '../../../../components/destroyable';
import {FloatCell, FloatLayout} from '../../../../components/float-layout';
import {Point} from '../../../../components/layout/abstract-units';
import {CellSizeObserverService} from '../../layout/cell/cell-size-observer.service';

const MOVING_CLASS = '-moving';
const HIDDEN_CLASS = '-hidden';
const FIXED_POS = '-fixed-pos';

@Component({
    selector: 'float-cell',
    templateUrl: './float-cell.component.html',
    styleUrls: ['./float-cell.component.scss'],
    providers: [
        CellSizeObserverService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FloatCellComponent implements OnInit  {

    @Input()
    public cell: FloatCell;

    @Input()
    public layoutResize$: Observable<any>;

    @Input()
    public floatLayout: FloatLayout;

    public readonly destroy$ = destroy$();

    @HostBinding(`class.${MOVING_CLASS}`)
    public isMoving: boolean = false; // To be changed from outside.

    @HostBinding(`class.${HIDDEN_CLASS}`)
    public isHidden: boolean = false; // To be changed from outside.

    constructor(
        public elementRef: ElementRef,
        private renderer: Renderer2
    ) {}

    public ngOnInit(): void {
        this.updatePosition();
        this.listenToLayoutResize();
        this.listenToBringToFront();
    }

    public updatePosition(pos?: Point): void {
        pos = pos || (this.cell.display && this.cell.display.pos);

        if (pos) {
            const [x, y] = pos;
            const isPosFixed: boolean = !(x === null || y === null);

            this.toggleClass(FIXED_POS, isPosFixed);

            if (isPosFixed) {
                this.setStyles({
                    top: `${y}px`,
                    left: `${x}px`
                });
            } else {
                this.setStyles({
                    top: null,
                    left: null
                });
            }
        }
    }

    private listenToLayoutResize(): void {
        this.layoutResize$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => this.updatePosition());
    }

    private listenToBringToFront(): void {
        merge(
            fromEvent(this.elementRef.nativeElement, 'mousedown'),
            fromEvent(this.elementRef.nativeElement, 'touchstart')
        ).pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => this.floatLayout.bringCellToFront(this.cell));
    }

    private setStyles(stylesMap: Partial<CSSStyleDeclaration>): void {
        _.forEach(stylesMap, (value, key: string) =>
            this.renderer.setStyle(this.elementRef.nativeElement, key, value)
        );
    }

    private toggleClass(className: string, state: boolean): void {
        const renderer = this.renderer;
        const element  = this.elementRef.nativeElement;

        if (state) {
            renderer.addClass(element, className);
        } else {
            renderer.removeClass(element, className);
        }
    }

}
